<div class="field">
    <label for="">{{label}}</label>
    <input *ngIf="controlType === 'input'" [type]="inputType" [formControl]="control"/>
    <textarea *ngIf="controlType === 'textarea'"  [formControl]="control" ></textarea>
    <div *ngIf="showErrors()" class="ui pointing red basic label">
        <p *ngIf="control.errors.required">
            Value is required
        </p>
        <p *ngIf="control.errors.email">
            Enter a valid email
        </p>
        <p *ngIf="control.errors.minlength">
            Value entered is 
            {{control.errors.minlength.actualLength}}
            characters long, but it must be at least
            {{control.errors.minlength.requiredLength}} 
            characters
        </p> 
        <p *ngIf="control.errors.maxlength">
            Value entered is 
            {{control.errors.maxlength.actualLength}}
            characters long, but it cannot be longer than
            {{control.errors.maxlength.requiredLength}} 
            characters
        </p>
        <p *ngIf="control.errors.pattern">
            Invalid format
        </p>
        <p *ngIf="control.errors.nonUniqueUsername">
            Username is taken
        </p>
        <p *ngIf="control.errors.noConnection">
            Can't tell if username is taken
        </p>
    </div>
</div>
